<div class="tiime-badge" [ngClass]="badgeClass">
  <span>{{ badge }}</span>
  @if (badgeCounter) {
    <span class="badge-counter">
      {{ badgeCounter }}
    </span>
  }
</div>
